import { D as e, M as t, N as n, O as r, Oc as i, P as a, T as o, _ as s, _l as c, c as l, d as u, h as d, i as f, k as p, l as m, m as h, r as g, s as _, u as v, v as y, vl as b, y as x } from "./apiUrls-2n3hzoxF.js";
//#region src/composables/useCoreApiService.ts
var S = () => c.getConfig().auth, C, w = (e) => {
	if (!e.token) throw Error("Token is required");
	let t = {
		auth: e.token,
		baseUrl: e.baseUrl,
		querySerializer: b(),
		headers: { "x-dmp-feature-flags": "x-dmp-no-tracking" }
	};
	return C = e.baseUrl, e.locale && (t.headers = {
		...t.headers,
		"Accept-Language": e.locale
	}), c.setConfig(t), e.token;
}, T = (e) => {
	c.setConfig({ headers: {
		...c.getConfig().headers,
		"Accept-Language": e
	} });
}, E = async (e) => (await h({
	baseUrl: C,
	query: { shopId: e }
})).data.results, D = async (t) => (await e({
	baseUrl: C,
	body: t
})).data, O = async (e) => (await f({
	baseUrl: C,
	path: { ids: e.join(";") }
})).data, k = async (e) => (await d({
	baseUrl: C,
	path: { notification_group_id: e }
})).data.results, A = async (e, n) => (await t({
	baseUrl: C,
	path: {
		notification_group_id: e,
		notification_template_id: n.path.notification_template_id
	},
	body: n.body
})).data, j = async (e, t) => (await l({
	baseUrl: C,
	path: {
		notification_group_id: e,
		notification_template_id: t
	}
})).data, M = async (e, t) => (await v({
	baseUrl: C,
	path: {
		notification_group_id: e,
		notification_template_id: t
	}
})).data, N = async (e) => {
	await m({
		baseUrl: C,
		path: { notification_group_id: e }
	});
}, P = async (e) => {
	await _({
		baseUrl: C,
		path: { notification_group_id: e }
	});
}, F = async (e, t) => (await a({
	baseUrl: C,
	path: {
		notification_group_id: e,
		notification_template_id: t
	}
})).data, I = async (e, t, n) => {
	let r = n?.useDirectPrinting && n?.printerGroupId ? `application/vnd.shipment_label+pdf+print;printer-group-id=${n?.printerGroupId}` : "application/pdf", i = { ...n?.useDirectPrinting ? { Accept: r } : { Accept: "*/*" } };
	return await x({
		baseUrl: C,
		query: t,
		headers: { ...i },
		path: { ids: e.join(";") },
		signal: AbortSignal.timeout(6e4)
	});
}, L = async (e) => (await s({
	baseUrl: C,
	query: e
})).data.data, R = async (e, t) => (await y({
	baseUrl: C,
	path: { ids: e.join(";") },
	query: t
})).data.data, z = async (e) => (await u({
	baseUrl: C,
	query: e,
	headers: { Accept: "application/json;charset=utf-8" },
	responseValidator: async (e) => await i.parseAsync(e)
})).data.data, B = async (e) => (await p({
	baseUrl: C,
	body: e
})).data.data.shipments, V = async (e) => {
	await n({
		baseUrl: C,
		body: e
	});
};
function H() {
	return {
		getToken: S,
		initClient: w,
		setAcceptLanguageHeader: T,
		getNotificationGroups: E,
		postNotificationGroups: D,
		deleteNotificationGroups: O,
		getNotificationTemplates: k,
		putNotificationTemplate: A,
		disableNotificationTemplate: j,
		enableNotificationTemplate: M,
		enableAllNotificationTemplatesByGroup: N,
		disableAllNotificationTemplatesByGroup: P,
		sendTestNotification: F,
		getShipmentLabels: I,
		getShipments: L,
		getShipmentsById: R,
		getDeliveryOptions: z,
		postShipments: B,
		putShipments: V
	};
}
//#endregion
//#region src/composables/useShipmentCapabilitiesService.ts
var U = () => c.getConfig().auth, W = (e = { token: void 0 }) => {
	if (!e.token) throw Error("Token is required");
	let t = {
		baseUrl: g(e),
		auth: e.token,
		querySerializer: b(),
		headers: { Accept: "application/json;charset=utf-8;version=2.0" }
	};
	return e.locale && (t.headers = {
		...t.headers,
		"Accept-Language": e.locale
	}), c.setConfig(t), e.token;
}, G = (e) => {
	c.setConfig({ headers: {
		...c.getConfig().headers,
		"Accept-Language": e
	} });
}, K = async (e) => (await o({ body: e })).data.results;
function q() {
	return {
		getToken: U,
		initClient: W,
		setAcceptLanguageHeader: G,
		postShipmentsCapabilities: K
	};
}
//#endregion
//#region src/composables/useShipmentPricingService.ts
var J = () => c.getConfig().auth, Y = (e = { token: void 0 }) => {
	if (!e.token) throw Error("Token is required");
	let t = {
		baseUrl: g(e),
		auth: e.token,
		querySerializer: b(),
		headers: { Accept: "application/json;charset=utf-8;version=2.0" }
	};
	return e.locale && (t.headers = {
		...t.headers,
		"Accept-Language": e.locale
	}), c.setConfig(t), e.token;
}, X = (e) => {
	c.setConfig({ headers: {
		...c.getConfig().headers,
		"Accept-Language": e
	} });
}, Z = async (e) => (await r({ body: e })).data ?? null;
function Q() {
	return {
		getToken: J,
		initClient: Y,
		setAcceptLanguageHeader: X,
		postShipmentsRates: Z
	};
}
//#endregion
export { q as n, H as r, Q as t };
